import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import React, { useEffect, useState } from 'react';
import { formatearFechaCompleta, formatearFechaCorta, formatearPrecio, toYYYYMMDD} from '../../../utils/utils'; 
import Select from 'react-select';
import { useFormOptions } from '../../../config/constants';
import FileUploader from '../../../components/FileUploader';
import { useDialog } from '../../../components/Dialogs/Dialogprovider';
import { toast } from 'react-toastify';
import { Eye , AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import HistorialPagosWidget from './Modulos/ListaPagos';
import { formPagoInicial } from '../../../objetos/objeto_servicio';


const ModuloPagos = ({servicio}) => {
    const servicioReferido = servicio.referidoPor === "" ? false : true;
    const [formPago, setFormPago] = useState(formPagoInicial);
    const {tipoReferenciasPagosOptions,cuentasBancariasListOptions} = useFormOptions();
    const navigate = useNavigate();

    const dialogs = useDialog();
    const PIN_ACCIONES = process.env.REACT_APP_PINACCIONES;

    //pagos existentes
    const [infoDuplicados, setInfoDuplicados] = useState(null);
    
    const {
        addPago,
        searchArchivoDrive,
        deletePago,
        getPagosPorReferencia,
    } = useContabilidadModel();

    const [estadosArchivos, setEstadosArchivos] = useState({});

    //errores
    const [validationError, setValidationError] = useState('');

    // Dentro de tu componente AdminPagosServiciosTab
    const verificarArchivosAutomaticamente = async (pagos) => {
            if (!pagos || pagos.length === 0) return;
    
            // Creamos un objeto para guardar todos los nuevos estados
            const nuevosEstados = {};
    
            // Usamos Promise.all para hacer todas las búsquedas en paralelo (más eficiente)
            const promesas = pagos.map(async (pago) => {
              const pagoId = pago.id || pago.indexPago;
              if (!pago.indexPago) {
                return; // Si no hay archivo, no hacemos nada
              }
    
              try {
                const resultado = await searchArchivoDrive(servicio.nombreEmpresa, pago.indexPago);
                if (resultado && resultado.success) {
                  nuevosEstados[pagoId] = { status: 'found', data: resultado.data };
                } else {
                  nuevosEstados[pagoId] = { status: 'not_found' };
                }
              } catch (error) {
                nuevosEstados[pagoId] = { status: 'not_found' };
              }
            });
    
            // Esperamos a que todas las verificaciones terminen
            await Promise.all(promesas);
    
            // Actualizamos el estado una sola vez con todos los resultados
            setEstadosArchivos(nuevosEstados);
    };

    useEffect(() => {
            // Verificamos si ya hay pagos cargados en el objeto servicio
            if (servicio && servicio.pagos && servicio.pagos.length > 0) {
              verificarArchivosAutomaticamente(servicio.pagos);
            }
    }, [servicio]); 

    //validar errores para desactiar pago
    useEffect(() => {
      const valorIngresado = parseFloat(formPago.valor) || 0;
      const tipoPago = formPago.tipopago;

      // Si no hay tipo de pago o el valor es 0, no hay nada que validar.
      if (!tipoPago || valorIngresado <= 0) {
          setValidationError('');
          return;
      }

      // Usamos un switch para manejar cada caso de forma ordenada.
      switch (tipoPago) {
            case 'CLIENTES': {
                const saldoPendiente = servicio.getSaldoPendienteCliente ? servicio.getSaldoPendienteCliente() : 0;
                if (valorIngresado > saldoPendiente) {
                    setValidationError(`El pago no puede exceder el saldo pendiente de ${formatearPrecio(saldoPendiente)}.`);
                } else {
                    setValidationError('');
                }
                break;
            }
            case 'REEMBOLSOCLIENTE': {
                const totalPagado = servicio.getSumaBalanceClientes ? servicio.getSumaBalanceClientes() : 0;
                if (valorIngresado > totalPagado) {
                    setValidationError(`El reembolso no puede ser mayor al total pagado por el cliente (${formatearPrecio(totalPagado)}).`);
                } else {
                    setValidationError('');
                }
                break;
            }
            case 'TUTOR': {
                const saldoPendiente = servicio.getSaldoPendienteTutor ? servicio.getSaldoPendienteTutor() : 0;
                if (valorIngresado > saldoPendiente) {
                    setValidationError(`El pago no puede exceder el saldo pendiente del tutor de ${formatearPrecio(saldoPendiente)}.`);
                } else {
                    setValidationError('');
                }
                break;
            }
            case 'REEMBOLSOTUTOR': {
                const totalPagado = servicio.getSumaPagosTutores ? servicio.getSumaBalanceTutor() : 0;
                if (valorIngresado > totalPagado) {
                    setValidationError(`El reembolso no puede ser mayor al total pagado al tutor (${formatearPrecio(totalPagado)}).`);
                } else {
                    setValidationError('');
                }
                break;
            }
            case 'REFERIDOS': {
                const gananciaReferido = servicio.gananciaReferido || 0;
                const pagadoReferido = servicio.getSumaPagosReferidos ? servicio.getSumaPagosReferidos() : 0;
                const pendienteReferido = gananciaReferido - pagadoReferido;
                if (valorIngresado > pendienteReferido) {
                    setValidationError(`El pago no puede exceder la ganancia pendiente del referido (${formatearPrecio(pendienteReferido)}).`);
                } else {
                    setValidationError('');
                }
                break;
            }
            // Puedes agregar más casos si tienes otros tipos de pago, como "Reembolso de Referido".
            default:
                // Si el tipo de pago no coincide con ninguna regla, limpiamos el error.
                setValidationError('');
                break;
      }

    }, [formPago.valor, formPago.tipopago, servicio]); 

    //obtener pagos relacionados
    useEffect(() =>{

      console.log("a obtener pagos relacionados",formPago.referencia,formPago.fechapago);
      
      if (!formPago.referencia || !formPago.fechapago) {
        setFormPago(prev => ({ ...prev, yaExiste: false }));
        setInfoDuplicados(null);
        return;
      }

      const delayDebounceFn = setTimeout(async () => {
            try {
                const fechaObj = new Date(formPago.fechapago);
                
                // Llamamos a tu función
                const duplicados = await getPagosPorReferencia(
                    fechaObj, 
                    servicio.nombreEmpresa, 
                    formPago.referencia
                );

                setInfoDuplicados(duplicados);

                // 3. Determinamos si existe (True/False)
                const existe = duplicados.totalPagos != 0;

                if (existe) {
                    setInfoDuplicados(duplicados);
                } else {
                    setInfoDuplicados(null); // Si es 0 o null, ocultamos la alerta amarilla
                }

                setFormPago(prev => {
                    if (prev.yaExiste !== existe) {
                      const linkEncontrado = duplicados.pagosDetallados?.[0]?.linkPago || '';

                        return { 
                          ...prev, 
                          yaExiste: existe,
                          linkPago: linkEncontrado,
                        };
                    }
                    return prev;
                });

            } catch (error) {
                console.error("Error verificando referencia:", error);
            }
      }, 800); // 800ms de espera

      return () => clearTimeout(delayDebounceFn);


    }, [formPago.referencia, formPago.fechapago]);

    const getOptionFromValue = (options, value) => {
        if (!value || !options || options.length === 0) return null;
        return options.find(option => option.value === value) || null;
    };


    const handleSelectChange = (selectedOption, { name }) => {
        console.log("a actualziar",selectedOption,name);
        setFormPago({
          ...formPago,
          [name]: selectedOption ? selectedOption.value : ''
        });

    };

    const handleRegistrarPago = async() =>{

      //realizar pago
      const procederConPago = async() =>{
        const tiposPagoConPin = ['REEMBOLSOCLIENTE', 'REEMBOLSOTUTOR'];

      if(tiposPagoConPin.includes(formPago.tipopago)){

        const onConfirmReembolso = async (enteredPin) => {
        
        if (enteredPin === PIN_ACCIONES) {
          // PIN Correcto
          console.log("PIN correcto. Registrando reembolso...");

          try {
            const response = await addPago(formPago, servicio.nombreEmpresa, servicio.codigo);
            console.log("la respuesta obtenida es", response);

            if (response) {
              setFormPago(formPagoInicial);
              dialogs.showSuccess('Reembolso registrado correctamente.');
            } else {
              dialogs.showError('Hubo un error al registrar el reembolso.');
            }
          } catch (error) {
            console.error("Error en addPago:", error);
            dialogs.showError(`Ocurrió un error inesperado: ${error.message}`);
          }

        } else {
          // PIN Incorrecto
          toast.error(`Error: la contraseña no es correcta`);
        }
      };

      // 5. Muestra el diálogo de confirmación con PIN
      dialogs.showConfirmWithPin(
        `Estás a punto de registrar un ${formPago.tipopago}. Esta acción requiere autorización.`,
        onConfirmReembolso, // Pasa tu función de callback
        'Confirmar Reembolso'
      );

      }else{
        const response = await addPago(formPago,servicio.nombreEmpresa,servicio.codigo);

        console.log("la respuesta obtenida es",response);

        if(response){
          setFormPago(formPagoInicial);
        }
      }
      }

      //validar que la fecha no sea antes a hoy
      const fechaInput = formPago.fechapago;
      if (fechaInput) {
        const fechaPago = new Date(fechaInput);
        const fechaActual = new Date();
        
        // Normalizamos a las 00:00:00 para comparar solo el día, no la hora exacta
        fechaPago.setHours(0, 0, 0, 0);
        fechaActual.setHours(0, 0, 0, 0);

        if (fechaPago < fechaActual) {
          // Si la fecha es anterior a hoy, pedimos confirmación
          dialogs.showConfirm(
            `Estás registrando un pago con fecha PASADA (${formatearFechaCompleta(fechaInput)}). ¿Deseas continuar?`,
            procederConPago, // <--- Si dice "Sí", ejecutamos la función encapsulada
            'Advertencia de Fecha'
          );
          return; // Importante: Detenemos la ejecución aquí hasta que el usuario responda el dialog
        }
      }

      await procederConPago();

    };

    const handleVerServicio = (servicio) => {
      // Navegar a detalles de solicitud
      navigate(`/contabilidad/detalles_servicio/${servicio.nombreEmpresa}/${servicio.codigo}`);
    };

    //Eliminar pago
    const handleDeletePago = (pagoId) => {
      console.log("Intentando eliminar el pago id:", pagoId);

      // 3. Define la función que se ejecutará al confirmar
      // Esta función recibirá el 'enteredPin' desde el diálogo
      const onConfirmDeletion = (enteredPin) => {
        
        if (enteredPin === PIN_ACCIONES) {
          // PIN correcto: elimina el pago y muestra éxito
          deletePago(pagoId, servicio.nombreEmpresa, servicio.codigo);
          //dialogs.showSuccess('El pago ha sido eliminado correctamente.');

        } else {
          // PIN incorrecto: muestra error
          toast.error(`Error: la contraseña no es correcta`);
        }
      };

      // 4. Llama a tu nuevo diálogo de confirmación con PIN
      dialogs.showConfirmWithPin(
        `¿Estás seguro de que deseas eliminar este pago? Esta acción requiere autorización.`,
        onConfirmDeletion, // Pasa la función de callback
        'Confirmar Eliminación'
      );
    };

    const resumenFinanciero = servicio.getResumenFinanciero ? servicio.getResumenFinanciero() : null;

    return(
        <div className="space-y-6">
          {/* ESTADÍSTICAS GENERALES */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            {/* Pagos de Clientes */}
            <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-blue-900">Pagos de Clientes</h3>
                <div className="bg-blue-600 p-2 rounded-full">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total a cobrar:</span>
                  <span className="font-medium">{formatearPrecio(servicio.preciocobrado || 0)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total pagado:</span>
                  <span className="font-medium text-green-600">
                    {formatearPrecio(servicio.getSumaPagosClientes ? servicio.getSumaBalanceClientes() : 0)}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Pendiente:</span>
                  <span className={`font-medium ${
                    (servicio.getSaldoPendienteCliente ? servicio.getSaldoPendienteCliente() : 0) > 0 
                      ? 'text-red-600' 
                      : 'text-green-600'
                  }`}>
                    {formatearPrecio(servicio.getSaldoPendienteCliente ? servicio.getSaldoPendienteCliente() : 0)}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-2">
                  {resumenFinanciero?.estadisticas.movimientosClientes || 0} movimientos
                </div>
              </div>
            </div>

            {/* Pagos de Tutores */}
            <div className="bg-amber-50 rounded-lg p-6 border border-amber-200">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-semibold text-amber-900">Pagos a Tutores</h3>
                <div className="bg-amber-600 p-2 rounded-full">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total a pagar:</span>
                  <span className="font-medium">{formatearPrecio(servicio.preciotutor || 0)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Total pagado:</span>
                  <span className="font-medium text-green-600">
                    {formatearPrecio(servicio.getSumaBalanceTutor ? servicio.getSumaBalanceTutor() : 0)}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Pendiente:</span>
                  <span className={`font-medium ${
                    (servicio.getSaldoPendienteTutor ? servicio.getSaldoPendienteTutor() : 0) > 0 
                      ? 'text-red-600' 
                      : 'text-green-600'
                  }`}>
                    {formatearPrecio(servicio.getSaldoPendienteTutor ? servicio.getSaldoPendienteTutor() : 0)}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-2">
                  {resumenFinanciero?.estadisticas.movimientosTutores || 0} movimientos
                </div>
              </div>
            </div>

            {/* Pagos de Referidos */}
            {servicioReferido && (
              <div className="bg-purple-50 rounded-lg p-6 border border-purple-200">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="font-semibold text-purple-900">Pagos Referidos</h3>
                  <div className="bg-purple-600 p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Total pagado:</span>
                    <span className="font-medium text-purple-600">
                      {formatearPrecio(servicio.getSumaPagosReferidos ? servicio.getSumaPagosReferidos() : 0)}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Ganancia esperada:</span>
                    <span className="font-medium">{formatearPrecio(servicio.gananciaReferido || 0)}</span>
                  </div>
                  <div className="text-xs text-gray-500 mt-2">
                    {resumenFinanciero?.estadisticas.movimientosReferidos || 0} movimientos
                  </div>
                </div>
              </div>
            )}

          </div>

            <button
            onClick={() => 
                handleVerServicio(servicio)
              }
              className="flex-1 bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-1 text-xs font-medium"
            >
              <Eye size={12} />
                Ver Servicio
            </button>

          {/* SECCIÓN DE REGISTRO Y HISTORIAL */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

            {/* FORMULARIO DE REGISTRO DE PAGOS */}
            <div className="bg-white rounded-lg border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Registrar Nuevo Pago</h3>
              <div className="space-y-4">
                {/* Tipo de Pago */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Tipo de pago
                  </label>
                  <Select
                    name="tipopago"
                    value={getOptionFromValue(tipoReferenciasPagosOptions, formPago.tipopago)}
                    onChange={handleSelectChange}
                    options={tipoReferenciasPagosOptions}
                    placeholder="Selecciona el tipo de pago"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    required
                  />
                </div>

                {/* Valor del Pago */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Valor de pago
                  </label>
                  <input
                    type="number"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Valor de pago"
                    value={formPago.valor || ''}
                    onChange={(e) => setFormPago({...formPago, valor: e.target.value})}
                  />
                </div>

                {/* ✅ AQUÍ MOSTRAMOS EL MENSAJE DE ERROR SI EXISTE */}
                {validationError && (
                  <p className="text-red-600 text-sm mt-1 font-semibold">
                    {validationError}
                  </p>
                )}

                {/* Metodo de Pago */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Metodo de pago
                  </label>
                  <Select
                    name="metodopago"
                    value={getOptionFromValue(cuentasBancariasListOptions, formPago.metodopago)}
                    onChange={handleSelectChange}
                    options={cuentasBancariasListOptions}
                    placeholder="Selecciona el tipo de pago"
                    isClearable
                    isSearchable
                    classNamePrefix="react-select"
                    required
                  />
                </div>

                {/* Referencia */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Referencia
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Referencia"
                    value={formPago.referencia || ''}
                    onChange={(e) => setFormPago({...formPago, referencia: e.target.value})}
                  />
                </div>

                {/* Fecha de pago */}
                <div className="max-w-md">
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Fecha de pago
                  </label>
                  <input
                    type="datetime-local" 
                    value={formPago.fechapago}
                    onChange={(e) => setFormPago({...formPago, fechapago: e.target.value})}
                    className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                      'border-gray-300'
                    }`}
                    required
                  />
                </div>

                {/* Seleccionar archivo */}
                {!formPago?.yaExiste ? (
                   <FileUploader 
                    formData={formPago}
                    setFormData={setFormPago}
                    fieldName="archivoPago"
                    allowedTypes={[
                      'application/pdf',
                      'image/jpeg',
                      'image/jpg',
                      'image/png',
                      'image/gif',
                      'image/webp',
                      'image/bmp',
                      'image/svg+xml'
                    ]}
                    maxSize={10 * 1024 * 1024}
                    label="Archivo de pago"
                    multiple={false}
                  />
                ): (
                  <div className="aviso-existente" style={{ padding: '10px', backgroundColor: '#e0f7fa', color: '#006064', borderRadius: '4px' }}>
                    <strong>REFERENCIA ENCONTRADA:</strong> NO HACE FALTA SUBIR IMAGEN
                  </div>
                )}
               

                 {/* === SECCIÓN DE ADVERTENCIA DE PAGOS DUPLICADOS === */}
                 {infoDuplicados && infoDuplicados.totalPagos != 0 && (
                    <div className="mt-4 bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded shadow-sm animate-fadeIn">
                        
                        {/* Cabecera de la Alerta */}
                        <div className="flex justify-between items-center mb-2">
                            <div className="flex items-center">
                                <AlertTriangle className="h-5 w-5 text-yellow-600 mr-2" />
                                <div>
                                    <p className="text-sm font-bold text-yellow-800">
                                        Referencia ya registrada
                                    </p>
                                    <p className="text-xs text-yellow-700">
                                        Total acumulado: 
                                        <span className="font-bold ml-1 text-yellow-900 text-sm">
                                            {formatearPrecio(infoDuplicados.totalPagos)}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Lista de Pagos Detallados */}
                        {infoDuplicados.pagosDetallados && infoDuplicados.pagosDetallados.length > 0 && (
                            <div className="mt-2 bg-white/50 rounded p-2 max-h-32 overflow-y-auto">
                                <p className="text-xs font-semibold text-yellow-800 mb-1 border-b border-yellow-200 pb-1">
                                    Detalle de registros:
                                </p>
                                <ul className="space-y-1">
                                    {infoDuplicados.pagosDetallados.map((pago, index) => (
                                        <li key={index} className="flex justify-between items-center text-xs text-gray-700 p-1 hover:bg-yellow-100 rounded transition-colors">
                                            <div className="flex flex-col">
                                                <span className="font-medium text-gray-800">{pago.tipopago}</span>
                                                {/* Opcional: mostrar la empresa si viene en el objeto */}
                                                {pago.nombreEmpresa && (
                                                    <span className="text-[10px] text-gray-500">{pago.nombreEmpresa}</span>
                                                )}
                                            </div>
                                            <span className="font-mono font-bold text-gray-900">
                                                {formatearPrecio(pago.valor)}
                                            </span>

                                            <span className="font-mono font-bold text-gray-900">
                                                {formatearFechaCompleta(pago.fechapago)}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                 )}

                 {formPago?.yaExiste.toString()}

                {/* Boton archivo */}
                <button 
                  className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                  onClick={handleRegistrarPago}
                  type="button"
                  disabled={
                    !formPago.valor || 
                    !formPago.tipopago || 
                    !formPago.metodopago || 
                    !formPago.referencia ||
                    !!validationError
                  }
                >
                  Registrar Pago
                </button>

              </div>
            </div>

            <HistorialPagosWidget 
              pagos={servicio.pagos} // O solicitud.pagos
              handleDeletePago={handleDeletePago}
              estadosArchivos={estadosArchivos}
            />

          </div>

        </div>
    );

}

export default ModuloPagos
